import React from 'react';
import { Link } from 'react-router-dom';

const CustomerDataAcquisitionPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/LJM-Blog-Images-9.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              Where can I acquire customer<br />
              data to build my business?
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Customer data lists are essential to all industries who are looking to expand their business. Thanks to the evolvement of technology, obtaining customer data has become an easier process due to the many resources available to assist your business.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    When used efficiently, customer data will provide a broader insight of the market, which can then be used for improving and expanding on marketing strategies. Customer data can also help to improve relationships between a company and its consumers. By using analytical tools, campaigns can be analysed to identify which ones have been highly engaged with. By producing marketing materials with the preference of the customers in mind, this becomes more personalised to them.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>Why is customer data important?</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    To build your customer email database, obtaining customer data is a necessity. An email database is a list of customer's names and email addresses which would be used for marketing purposes such as sending company news.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Therefore, it is important to ensure that your customer email database is regularly updated and refreshed; users may unsubscribe from mailing lists or email addresses will become inactive which will reduce the number of customers receiving the mailings.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Collecting data is a must for companies who are customer focused as it will help to build trust. By regularly sending company updates, special offers or important news, this will keep customers informed and involved with the development of the business. This can all become possible by having an effective consumer data list in place.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    At Lloyd James, we focus on enriching existing data to ensure accuracy of data, quality, coverage and depth. <Link to="/product" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>Click here</Link> to learn how we can enhance your customer and prospect data.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>How to collect data</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Customer data can be collated in many ways such as:
                  </p>

                  <p className="text-gray-900 font-semibold mb-3 text-lg">Data suppliers</p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Data suppliers are one of the most popular ways of collecting customer data. There are many data supplier companies who work to produce and supply high quality consumer data lists for third parties. Many data supplier companies guarantee that the lists they produce will assist with gaining new customers whilst also enhancing marketing and sales strategies. As well as providing customer databases, other services can be made available such as data cleansing and storage. By having an effective system in place, this will ensure growth and success for a company.
                  </p>

                  <p className="text-gray-900 font-semibold mb-3 text-lg">Surveys</p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    By providing customers with the opportunity to share their thoughts on your business, this will help to enhance services and strategies. Many surveys include an option for customers to provide their contact details. Customers will be more inclined to pass on their details on surveys that ask for thoughts and opinions, this is an efficient way of collecting customer information.
                  </p>

                  <p className="text-gray-900 font-semibold mb-3 text-lg">Website analytics</p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Analysing your data online will help to collect and understand your customer data. These include statistics such as website clicks and mailing subscription numbers. You will also learn how a customer entered your website e.g., from social media, an email, or a website link.
                  </p>

                  <p className="text-gray-900 font-semibold mb-3 text-lg">Online purchase data</p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    If you sell your products online, this is a beneficial way of collecting customer data. This is through a customer's purchasing history, as statistics such as items purchased and returned will be available to view. Accessing this data can help decisions within the business to be made.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    To ensure customers are aware of the personal information that will be stored/used for marketing purposes, it is important to have this clearly stated within the company's privacy policy which will be available to view online. This will avoid customers from being confused on how their data was collected.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    At Lloyd James we believe that delivering customer insight is an essential part of growth to a business as it is a key driver of performance and growth. <Link to="/contact" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>Click here</Link> to get in touch.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CustomerDataAcquisitionPage;